window.Bernie = window.Bernie || {};
var mod = require("-!/app/node_modules/cache-loader/dist/cjs.js!/app/node_modules/thread-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!/app/node_modules/ts-loader/index.js??ruleSet[1].rules[3].use[2]!/app/src/get-localization.ts");
Object.keys(mod).forEach(function (key) { window.Bernie[key] = mod[key]; });
module.exports = window.Bernie;